import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AppToolbarService } from 'src/app/components/toolbar/services/app-toolbar.service';
import { CST_RETURN_DISPOTITION, CST_TOOLBAR_BTN_EVENT } from '../../components/toolbar/app-tool-bar/app-tool-bar.component';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { HttpClient } from '@angular/common/http';
import { DataSnapResult, Formes } from 'src/app/classes/json-interface';
import { ArmaServConnection } from 'src/app/classes/info-connection';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { MatPaginator } from '@angular/material/paginator';
import { Location } from '@angular/common';


@Component({
  selector: 'app-shape',
  templateUrl: './shape.component.html',
  styleUrls: ['./shape.component.css'],
})
export class ShapeComponent implements OnInit {
  HTML_TABLE_HEADER_COL: string[] = ['SHAPE', 'Action'];
  HTML_TABLE_DATASOURCE: MatTableDataSource<ArmaRestShapeImage>;

  public HTML_INPUT_FILTER: string = '';
  public HTML_INPUT_PLIURE: string = 'any';
  public HTML_INPUT_MEASURE: string = 'any';
  public HTML_INPUT_ARC: string = 'any';
  public HTML_INPUT_3D: string = 'any';
  public HTML_INPUT_RADIUS: string = 'any';
  public HTML_INPUT_DIAMETER: string = 'any';
  public HTML_INPUT_180ANGLES: string = 'any';
  public HTML_INPUT_90ANGLES: string = 'any';
  public HTML_INPUT_135ANGLES: string = 'any';
  public HTML_INPUT_45ANGLES: string = 'any';
  public HTML_INPUT_COUPLERS: string = 'any';

  inProgressGetShape: boolean;

  @ViewChild('table', { static: false }) mTable!: MatTable<any>;
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild('scroll', {static: true}) mDivMainContent!: ElementRef<HTMLDivElement>;

  public mInput: inputShape[] = [
    {value: 'any', viewValue: 'Any'},
    {value: '0', viewValue: '0'},
    {value: '1', viewValue: '1'},
    {value: '2', viewValue: '2'},
    {value: '3', viewValue: '3'},
    {value: '4', viewValue: '4'},
    {value: '5', viewValue: '5'},
    {value: '6', viewValue: '6'},
    {value: '7', viewValue: '7'},
    {value: '8', viewValue: '8'},
    {value: '9', viewValue: '9'},
    {value: '10', viewValue: '10'},
    {value: '11', viewValue: '11'},
    {value: '12', viewValue: '12'},
    {value: '13', viewValue: '13'},
    {value: '14', viewValue: '14'},
    {value: '15', viewValue: '15'},
    {value: '16', viewValue: '16'},
    {value: '17', viewValue: '17'},
    {value: '18', viewValue: '18'},
    {value: '19', viewValue: '19'},
    {value: '20', viewValue: '20'},
  ];

  constructor(
    private mHttp: HttpClient,
    private mSanitizer: DomSanitizer,
    private mToolbar: AppToolbarService,
    private mlocation: Location
  ) {
    this.inProgressGetShape = false;
    this.HTML_TABLE_DATASOURCE = new MatTableDataSource<ArmaRestShapeImage>([]);
  }

  ngOnInit() {
    this.HTML_TABLE_DATASOURCE.paginator = this.paginator;
    this.mToolbar.setVisibility(true); // passe la navbar en visible sur la page
    this.mToolbar.toolbarPageTitle = 'Armaor Shape'; // defini le titre de la page
    this.mToolbar.setDisposition(CST_RETURN_DISPOTITION); // ajoute un bouton retour a la nav barre
    this.mToolbar.updateToolbarElementVisibility({
      MenuBtn: false,
      SiteSelect: false,
    }); // retire le bouton Menu & la selection de l'entreprise
    this.mToolbar
      .getObservableClick(true)
      .subscribe((next) => this.onToolbarItemClick(next));
    this.getShapesDefaultCatalog();

    this.HTML_TABLE_DATASOURCE.filterPredicate = (data: ArmaRestShapeImage, filter: any) => {

      function checkCodeForme(search: boolean, filter2: string, currentValue: any): boolean {
        if (search && filter2 && filter2 !== '' ) {
          const m = currentValue.match(filter2);
          search = m && m.length > 0;
        }
        return search;
      }

      function checkSelectQty(search: boolean, filter2: any, currentValue: any) {
        if (search && filter2 && filter2 !== 'any')
          search = filter2 == currentValue;
        return search;
      }
      function checkSelect(search: boolean, filter2: any, currentValue: any) {
        if (search && filter2 !== 'any')
          search = (filter2 == 'yes' && currentValue) || (filter2 == 'no' && !currentValue);
        return search;
      }

      let boolCheckFilterSearch = true; //recherche pour any
      boolCheckFilterSearch = checkCodeForme(boolCheckFilterSearch, this.HTML_INPUT_FILTER, data.Forme.CodeForme);
      boolCheckFilterSearch = checkSelectQty(boolCheckFilterSearch, this.HTML_INPUT_PLIURE, data.Forme.NbPliure);
      boolCheckFilterSearch = checkSelectQty(boolCheckFilterSearch, this.HTML_INPUT_MEASURE, data.Forme.NbCote);
      boolCheckFilterSearch = checkSelectQty(boolCheckFilterSearch, this.HTML_INPUT_ARC, data.Forme.NbCintrage);

      boolCheckFilterSearch = checkSelect(boolCheckFilterSearch, this.HTML_INPUT_3D, data.Forme.Is3DForme);
      boolCheckFilterSearch = checkSelect(boolCheckFilterSearch, this.HTML_INPUT_RADIUS, data.Forme.IsRay);
      boolCheckFilterSearch = checkSelect(boolCheckFilterSearch, this.HTML_INPUT_DIAMETER, data.Forme.IsDiam);
      boolCheckFilterSearch = checkSelect(boolCheckFilterSearch, this.HTML_INPUT_COUPLERS, data.Forme.HasCoupler);

      boolCheckFilterSearch = checkSelectQty(boolCheckFilterSearch, this.HTML_INPUT_180ANGLES, data.Forme.NbAngle180);
      boolCheckFilterSearch = checkSelectQty(boolCheckFilterSearch, this.HTML_INPUT_90ANGLES, data.Forme.NbAngle90);
      boolCheckFilterSearch = checkSelectQty(boolCheckFilterSearch, this.HTML_INPUT_135ANGLES, data.Forme.NbAngle135);
      boolCheckFilterSearch = checkSelectQty(boolCheckFilterSearch, this.HTML_INPUT_45ANGLES, data.Forme.NbAngle45);

      return boolCheckFilterSearch;
    };
  }

  async getShapesDefaultCatalog() {
    let catalogueForme: CatalogueForme;
    if (!this.inProgressGetShape) {
      this.inProgressGetShape = true;
      this.HTML_TABLE_DATASOURCE.data = [];
      try {
        catalogueForme = await (await ArmaServConnection.aGET(this.mHttp, "GetShapesDefaultCatalog")).result[0];
        for (let i = 0; i < catalogueForme.FormesCatalogue.length; i++) {
          if (catalogueForme.FormesCatalogue[i].CodeForme !== "") {
            this.HTML_TABLE_DATASOURCE.data.push({
              interfaceshape_img: "", // Image télécharger plus tard en async pour gain de temps
              IdCatalogue: catalogueForme.IDCatalogue,
              Forme: catalogueForme.FormesCatalogue[i]
            });
          }
        }
        this.loadIntervaleImageShape(this.paginator.pageIndex*this.paginator.pageSize, ((this.paginator.pageIndex+1)*this.paginator.pageSize)-1);
        this.mTable.renderRows();
        this.HTML_TABLE_DATASOURCE.paginator = this.paginator;
      } catch (e) {
        console.error(e);
      } finally {
        this.inProgressGetShape = false;
      }
    }
  }

  // création d'une fonction qui permet de transformé une image en une safe url lisable par angular
  async getImageShapes(IDCatalogue: number, CodeForme: string): Promise<SafeUrl> {
    return await ArmaServConnection.getSafeUrlImgFromDatasnap(this.mHttp, this.mSanitizer, "GetImageShape", [IDCatalogue, CodeForme]);
  }

  // binding de l'event return sur le bouton Retour
  private onToolbarItemClick(eventName: string) {
    switch (eventName) {
      case CST_TOOLBAR_BTN_EVENT.Return:
        this.mlocation.back();
        break;
    }
  }

  onFilterChange() {
    this.HTML_TABLE_DATASOURCE.filter = new Date().getTime().toString();
    this.onPageChange();
  }

  DownloadShape(element: ArmaRestShapeImage) {
    ArmaServConnection.downloadFile(this.mHttp, "DownloadShape", [element.IdCatalogue.toString(), element.Forme.CodeForme], element.Forme.CodeForme + '.arm');
  }

  onPageChange() {
    setTimeout(() => {
      let debut = this.paginator.pageIndex*this.paginator.pageSize
      let fin = ((this.paginator.pageIndex+1)*this.paginator.pageSize)-1
      this.loadIntervaleImageShape(debut, fin)
      this.mDivMainContent.nativeElement.scroll(0, 0);
    });
  }

  async loadIntervaleImageShape(debut: number, fin: number) {
    // Debut fin index ?? trouvé un moyen de récuperer l'index de debut et de fin.
    for(let i = debut; i <= fin; i++){ // Boucle sur ton mat table ?? faire un for pour bouclé sur le mat-table ? donc HTMLDATASOURCE ?
      if( i < this.HTML_TABLE_DATASOURCE.filteredData.length && this.HTML_TABLE_DATASOURCE.filteredData[i].interfaceshape_img == ""){           // Si ta pas afficher l'image => getImageShape ?? faire un if qui dit que si urlImg = "" alors urlImg = getImageShape ? ce qui revient à mettre les ligne à deplacer ici ??
          this.HTML_TABLE_DATASOURCE.filteredData[i].interfaceshape_img = await this.getImageShapes( +this.HTML_TABLE_DATASOURCE.filteredData[i].IdCatalogue, this.HTML_TABLE_DATASOURCE.filteredData[i].Forme.CodeForme);
      }
    }
    this.mTable.renderRows();
  }

  onKeyCodeDown(event: KeyboardEvent) {
    console.log('event', event.key);
    if (event.key === " ") return true;
    let regex = new RegExp("^[a-zA-Z0-9]+$");
    if (!regex.test(event.key)) {
       event.preventDefault();
       return false;
    }
  }


}

interface ArmaRestShapeImage {
  interfaceshape_img: SafeUrl;
  IdCatalogue: string;    // Correspond à l'id du catalogue
  Forme: Formes;
}

interface inputShape {
  value: string;
  viewValue: string;
}

interface CatalogueForme {
  IDCatalogue: string;        // Int
  Libelle: string;            // String
  IsDefault: string;          // Boolean
  FormesCatalogue: Formes[];  // Array
}
